<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.id }}</td>
                            <td>{{ item.customer_name }}</td>
                            <td class="text-end">{{ item.amount | currency}}</td>
                            <td>{{ item.trade_content }}</td>
                            <td v-bind:style="{'color': display_color(item.status, recharge_status)}" >{{ item.status | display_value(recharge_status) }}</td>
                            <td>{{ item.created_at | display_date }}</td>
                            <td>{{ item.created_by }}</td>
                            <td class="text-center" v-if="!customer_id">
                                <v-icon medium class="mr-2" @click="requestCancelRecharge(item.id)" :disabled="!adminRole">delete</v-icon>
                            </td>
                            <td v-else></td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
    <v-dialog v-model="updateDialog" max-width="600px">
        <v-card>
        <v-card-title>
            <span class="title">Tạo mới thanh toán</span>
        </v-card-title>
        <v-card-text>
            <v-container grid-list-md pa-0>
            <v-layout row wrap>
                <v-flex lg12>
                    <v-autocomplete label="Khách hàng" v-model="newItem.customer_id" :items="customers" :item-text="getCustomerText" item-value="id" class="input-group--focused"></v-autocomplete>
                </v-flex>
                <v-flex lg12>
                    <h-currency-input label="Số tiền" v-model="newItem.amount" class="input-group--focused" :decimal="0"></h-currency-input>
                </v-flex>
                <v-flex lg12>
                    <v-text-field label="Ghi chú" v-model="newItem.trade_content" class="input-group--focused"></v-text-field>
                </v-flex>
            </v-layout>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1 white--text" @click="updateDialog = false">Đóng</v-btn>
            <v-btn @click="saveNewItem">Lưu lại</v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import { display_color } from "@/commons/formater";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering
    },
    props: ["customer_id"],
    data() {
        let dataType = configs.DATA_TYPE;
        return {
            display_color: display_color,
            updateDialog: false,
            newItem: {},
            headers: [{
                    text: "ID",
                    value: "id",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Khách hàng",
                    value: "customer_name",
                    filterable: true,
                    quickSearch: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Số tiền",
                    value: "amount",
                    align: "end",
                    filterable: true,
                    dataType: dataType["Number"]
                },
                {
                    text: "Nội dung",
                    value: "trade_content",
                    filterable: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Trạng thái",
                    value: "status",
                    filterable: true,
                    values: configs.RECHARGES,
                    dataType: dataType["Enum"]
                },
                {
                    text: "Ngày tạo",
                    value: "created_at",
                    filterable: true,
                    dataType: dataType["Date"]
                },
                {
                    text: "Người tạo",
                    value: "created_by",
                    filterable: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center",
                    sortable: false,
                    filterable: false
                }
            ],
            pagination: {...configs.PAGINATION},
            items_per_page: {...configs.ITEMS_PER_PAGE},
            viewName: "recharge_list",
            filterConditions: [],
            quickFilterConditions: [],
            dialogRecharge: false,
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
            recharge_status: configs.RECHARGES
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        loading() {
            this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleExportButton: !this.adminRole});
        },
        customer_id() {
            if(this.customer_id) {
                this.filter_data();
            }
        }
    },
    computed: {
        ...mapState({
            items: state => state.recharges.all.data,
            total_rows: state => state.recharges.all.total,
            loading: state => state.recharges.loading,
            customers: state => state.users.all.data,
        }),
        adminRole() {
            return this.$store.state.authentication.user.role == configs.ROLE_TYPE.Admin;
        }
    },
    methods: {
        add_date_range_filter() {
            if(this.filterConditions.length == 0) {
                let start_date = new URL(location.href).searchParams.get('start_date');
                let end_date = new URL(location.href).searchParams.get('end_date');
                if(start_date || end_date) {
                    _.remove(this.filterConditions, {'column': 'created_at'})
                }
                if(start_date) {
                    this.filterConditions.push({column: 'created_at', value: start_date, condition: "d_greater_than_or_equal"});
                }
                if(end_date) {
                    this.filterConditions.push({column: 'created_at', value: end_date, condition: "d_less_than_or_equal"});
                }
            }
        },
        filter_data: function () {
            this.add_date_range_filter();
            var param = {
                pagination: this.pagination,
                filter: [...this.filterConditions],
                quickFilter: this.quickFilterConditions
            };
            if(this.customer_id) {
                param.filter.push({column: 'customer_id', value: this.customer_id, condition: "equal"});
            }
            this.$store.dispatch("recharges/getList", param);
        },
        requestCancelRecharge(id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id, 'Bạn muốn hủy yêu cầu nạp tiền?');
        },
        cancelRecharge(rechargeId) {
            var selectedItem = _.find(this.items, {'id': rechargeId});
            if(selectedItem) {
                selectedItem.status = 1;
                this.$store.dispatch("recharges/setDetail", {
                    data: {status: 1},
                    id: rechargeId
                });
            }
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        createData() {
            this.updateDialog = true;
        },
        get_type_color(val, enums) {
            return this.$options.filters.display_color(val, enums);
        },
        getCustomerText(item) {
            return `${item.phone} - ${item.first_name}`
        },
        saveNewItem() {
            if(this.updateDialog) {
                this.updateDialog = false;
                let customer = _.find(this.customers, {'id': this.newItem.customer_id});
                this.newItem.customer_name = customer ? customer.first_name : '';
                this.$store.dispatch("recharges/setDetail", {data: this.newItem});
            }
        }
    },
    mounted() {
        this.$store.dispatch("users/getList", {filter: [{column: 'role', value: configs.ROLE_TYPE.Customer, condition: "equal"}]});
        this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleExportButton: !this.adminRole});
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.cancelRecharge(id);
        });
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.createData);
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
